import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: '#0C2340',
      accent: '#0C3D40'
    },
    secondary: {
      main: '#62400B'
    },
    accent: {
      main: '#143a6b'
    },
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    fontFamily: [
      'sans-serif',
      'Roboto',
      'Helvetica',
      'Arial',
    ].join(','),
  }
});

export default theme;
